<template>
  <div class="mt-3" v-show="chartseries.length > 0">
    <div class="d-flex">
      <h2 class="titleText--text">Variable execution over time</h2>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon  v-bind="attrs" size="medium"
          v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
        </template>
        <span> Variable execution over time</span>
      </v-tooltip>
    </div>
    <v-card flat class="custom-shadow mt-2">
      <v-card-text>
        <div>
          <div style="min-width: 300px">
            <search-select-box v-model="selectedSeries" :items="variableNames"/>
          </div>
          <div class="d-flex">
            <v-checkbox
              v-model="chartsFilter"
              value="Value"
              @change="getchartseries"
              class="ml-3"
              color="#2CD8C5"
              on-icon="mdi-checkbox-marked-circle"
              off-icon="mdi-checkbox-blank-circle-outline"
            >
              <template v-slot:label>
                <span
                  class="titleText--text font-weight-bold text-capitalize"
                  style="font-size: 14px"
                  >{{ variableItems[0] }}</span
                >
              </template>
            </v-checkbox>
            <v-checkbox
              v-model="chartsFilter"
              value="Volume"
              @change="getchartseries"
              class="ml-3"
              color="#2CD8C5"
              on-icon="mdi-checkbox-marked-circle"
              off-icon="mdi-checkbox-blank-circle-outline"
            >
              <template v-slot:label>
                <span
                  class="titleText--text font-weight-bold text-capitalize"
                  style="font-size: 14px"
                  >{{ variableItems[1] }}</span
                >
              </template>
            </v-checkbox>
          </div>
        </div>
        <v-row>
          <v-col md="12">
            <div id="chart">
              <apexchart
                style="z-index: 0px !important"
                height="350"
                ref="chart"
                :options="chartOptions"
                :series="filteredSeries"
              ></apexchart>
            </div>
          </v-col> </v-row
      ></v-card-text>
    </v-card>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import apifactory from "../api";
import SearchSelectBox from '@/components/SearchSelectBox.vue'

export default {
  components: {
    SearchSelectBox,
    apexchart: VueApexCharts,
  },
  props: {
    options: {
      type: [],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    ishavedata: {
      type: Boolean,
      required: true,
    },
    regionlist: {
      type: [],
      required: true,
    },
  },
  data: () => ({
    itemlist: [],
    strnodatafount: "No Data Found",
    ishavedata: false,
    level: "",
    levelSubNation: "subnational",
    issubnation: false,
    columndesc: [],
    colmnsname: [],

    //for chart
    prevstepQueryStringParm: [],
    prevstepQueryStringParmUrl: "",
    //filtervalue
    IndependentvariablesSelected: [],
    variableItems: [],
    chartsFilter: ["Value", "Volume"],
    chartsFilterNew: [],
    itemsplot: [],
    series: [],
    seriesfinal: [],
    chartseries: [],
    chartshow: 0,
    chartOptions: [],
    selectedSeries: [],
    variableNames: [],

    xaxismin: null,
    xaxismax: null,
    //end
    tempdatalist: [],
    listofregion: [],
    dataregionSelected: null,
  }),
  methods: {
    callApi_call_save_step3() {
      apifactory
        .call_get_step5_output()
        .then((res) => {
          //alert(JSON.stringify(res));
          if (res.status != 200) {
            alert("Sorry");
          } else {
            /*if (varclickfrom === 1) {
              this.$store.commit("ModelDataPreparation/ADD_ITEM", 1);
              this.$router.push("/adstockdecay");
            }*/
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    refresh(vardataregionSelected) {
      //alert('graph' +vardataregionSelected);
      this.dataregionSelected = vardataregionSelected;
      this.title = vardataregionSelected;
      this.loadData();
    },

    loadData() {
      apifactory
        .call_get_step5_output()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.cleardata();

            this.columndesc = res.data.column_description;
            this.level = res.data.project_level;
            this.colmnsname = [...Object.keys(res.data.data[0])];
            this.itemlist = res.data.data;
            //alert(this.level);
            if (this.level == "subnational") {
              this.isdatasublevel = true;
            } else {
              this.isdatasublevel = false;
            }
            this.ishavedata = true;

            this.variableItems = this.getvariableItems();
            this.IndependentvariablesSelected = this.getIndependentvariables();
            if (this.isdatasublevel) {
              this.itemsplot = res.data.data.filter(
                (a) => a.region == this.dataregionSelected
              );
            } else {
              this.itemsplot = res.data.data;
            }
            this.tempdatalist = this.filteredDatatemp();
            this.getchartseries();
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
    },
    cleardata() {
      this.variableItems = [];
      this.IndependentvariablesSelected = [];
      this.itemsplot = [];
      this.tempdatalist = [];
    },
    getprojectregions() {
      apifactory
        .call_get_project_region_list()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            //alert(JSON.stringify(res.data));
            this.listofregion = res.data;
          }
        })
        .catch(function (error) {
          alert("getprojectregions" + error);
          // return false;
        });
    },
    getvariableItems() {
      let temparray = [];
      temparray.push("sales");
      temparray.push("volume");
      return temparray;
    },
    getIndependentvariables() {
      let temparray = [];

      temparray = [...Object.keys(this.itemlist[0])];
      return temparray.filter(
        (a) =>
          a.toString() != this.columnfullName("sales_value") &&
          a.toString() != this.columnfullName("sales_volume") &&
          a.toString() != "region"
      );
    },
    filteredDatatemp() {
      const filterKeys = this.IndependentvariablesSelected;
      //alert(filterKeys);
      return this.itemsplot.filter((key) => filterKeys.includes(key));
    },

    //for chart

    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "date") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].date).getTime());
            var innerdata = [];
            innerdata.push(new Date(this.itemsplot[i].date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      //this.newseries = tkey;
      this.seriesfinal = [];
      this.series = [];
      this.series = tkey;
       this.chartsFilterNew=[];
      for (let el in this.chartsFilter) {
         if (this.chartsFilter[el] == "Value") {
          this.chartsFilterNew.push(this.columnfullName("sales_value"));
       
        }
        if (this.chartsFilter[el] == "Volume") {
          this.chartsFilterNew.push(this.columnfullName("sales_volume"));
       
        }
      }
      for (let el in this.series) {
        if (this.chartsFilterNew.includes(this.series[el].name)) {
          this.series[el].type = "line";
          this.seriesfinal.push(this.series[el]);
        }
      }

      for (let el in this.series) {
        for (let k in this.IndependentvariablesSelected) {
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            this.series[el].type = "bar";
            this.seriesfinal.push(this.series[el]);
          }
        }
      }

      let datelistarray = [];
      datelistarray = datelist;
      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;
      this.chartseries = [];
      this.selectedSeries = this.seriesfinal.slice(0, 5).map(item => item.name)
      this.chartseries = this.seriesfinal.filter(item => this.selectedSeries.includes(item.name))
      this.variableNames = this.seriesfinal.map(item => item.name)
      //alert(mindate);

      //chartOptions
      this.chartOptions = {
        chart: {
          height: 350,
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
          fontFamily: "Lato",
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            barHeight: "80%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1],
        },
        xaxis: {
          type: "datetime",
          min: mindate,
          max: maxdate,
          tickAmount: 6,
          labels: {
            style: {
              colors: "#9AA1A9",
              fontWeight: "bold",
            },
          },
        },

        yaxis: this.tempchartoptionnew(), // this.tempchartoption(),
        //yaxis: this.createchartoption(),
        tooltip: {
          fixed: {
            enabled: true,
            position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60,
          },
        },
        legend: {
          fontWeight: "bold",
          labels: {
            colors: "#9AA1A9",
          },
        },
      };
      this.chartshow = 1;
    },
    fetchVaribles(varfilterlist) {
      //alert('testfetchVaribles' + varfilterlist);
      this.variableItems = varfilterlist;
    },
    filteredChartsfinalseries() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelected) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            //alert(JSON.stringify(this.series[el]));
            data.push(this.series[el]);
          }
        }
      }
      return data;
    },
    createchartoption() {
      let output = [];
      var obj1 = new Object();
      obj1.seriesName = "One";
      var axisTicksobj1 = new Object();
      axisTicksobj1.show = true;
      obj1.axisTicks = axisTicksobj1;
      //  obj1.opposite = false;
      var axisBorderobj = new Object();
      axisBorderobj.show = true;
      axisBorderobj.color = "#008FFB";
      obj1.axisBorder = axisBorderobj;
      output.push(obj1);
      for (let el in this.chartseries) {
        if (this.chartseries[el].name === "sales") {
          var obj = new Object();
          obj.seriesName = this.chartseries[el].name;
          var axisTicksobj = new Object();
          axisTicksobj.show = true;
          obj.axisTicks = axisTicksobj;
          obj.opposite = true;
          output.push(obj);
        }

        //obj.axisBorder="Income";
        //obj.labels="Income";
        //obj.title="Income";
      }

      return output;
    },
    tempchartoption() {
      let output = [
        {
          axisTicks: {
            show: true,
          },
          toolbar: {
            show: false,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
          },
          title: {
            text: "CPP",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        {
          seriesName: "Income1",
          opposite: true,
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#00E396",
          },
          labels: {
            style: {
              colors: "#00E396",
            },
          },
          title: {
            text: "Effective Frequency",
            style: {
              color: "#00E396",
            },
          },
        },
      ];
      return output;
    },
    tempchartoptionnew() {
      let outputwithbase = [];
      let output = [];
      let issecondaxis = false;

      for (let el in this.chartseries) {
        // alert(this.series[el].name);
        for (let k in this.chartsFilterNew) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.chartseries[el].name === this.chartsFilterNew[k]) {
            issecondaxis = true;
            let objone1 = [
              {
                opposite: issecondaxis,
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#008FFB",
                },
                labels: {
                  style: {
                    colors: "#008FFB",
                  },

                  formatter: function (val) {
                    return val.toLocaleString("en-US");
                  },
                },
                title: {
                  text: this.chartseries[el].name,
                  style: {
                    color: "#008FFB",
                  },
                },
                tooltip: {
                  enabled: true,
                },
              },
            ];
            output.push(objone1[0]);
          }
        }
      }
      /*
      for (let el in this.chartseries) {
        if (this.chartseries[el].name === "sales") {
         
          issecondaxis = true;
           let objone1 = [
          {
            opposite: issecondaxis,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
              
            formatter: function (val) {
              return val.toLocaleString("en-US") ;
            },
            },
            title: {
              text: "Sales",
              style: {
                color: "#008FFB",
              },
            },
            tooltip: {
              enabled: true,
            },
          },
        ];
        output.push(objone1[0]);
        }

        //obj.axisBorder="Income";
        //obj.labels="Income";
        //obj.title="Income";
      }

      */
      //alert(issecondaxis);
      let objone = [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
            formatter: function (val) {
              return val.toLocaleString("en-US");
            },
          },
          title: {
            text: "Variables",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      ];

      //output.push(objonehide[0]);

      output.push(objone[0]);
      //outputwithbase.push(this.chartoptionbase()[0]);
      outputwithbase.push(output);
      return output;
    },
    chartoptionbase() {
      let baseoption = [];
      baseoption = [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
          },
          title: {
            text: "CPP",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      ];
      return baseoption;
    },
  },
  computed: {
     columnfullName() {
      return (theParam) => {
        let desc = [];
        desc = this.columndesc.filter((a) => a.description == theParam);
        return desc[0].column;
      };
    },
    filteredSeries () {
      return this.seriesfinal.filter(item => this.selectedSeries.includes(item.name))
    },
    fullName() {
      return (theParam) => {
        let desc = [];
        desc = this.columndesc.filter((a) => a.column == theParam);
        return desc[0].description;
      };
    },
    getdataallkeys() {
      //let templistnew=[];
      //templistnew = [...Object.keys(this.itemlist.keys)];
      //alert(JSON.stringify('dd' +  templistnew));
      //alert(this.itemlist[0].keys);
      //var obj= this.itemlist[0];

      //alert(Object.keys(obj));
      let temparray = [];
      temparray.push("sales");
      temparray.push("volume");
      return temparray;
      // temparray=[...Object.keys(this.itemlist[0])];
      // return temparray.filter(a=>a.toString() === 'date' && a.toString() === 'sales');
      //return JSON.stringify(Object.keys(obj));

      //return this.itemlist[0];
    },
    isdatasublevel() {
      if (this.level === this.levelSubNation) {
        return true;
      } else {
        return false;
      }
    },
    //for chart
    filteredChartsData1() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelected) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            //alert(JSON.stringify(this.series[el]));
            data.push(this.series[el]);
          }
        }
      }
      return data;
    },
    filteredChartsData() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        data.push(this.series[el]);
      }
      return data;
    },
  },
  mounted() {
    this.getprojectregions();
    this.refresh(this.title);
  },
};
</script>